export const DosesPicker = {
  1: '1º dose',
  2: '2º dose',
  3: '3º dose',
  4: '4º dose'
};

export enum ProfessionalTitlePicker {
  CRM = 'Médico (com CRM)',
  RMS = 'Médico (com RMS)',
  CRO = 'Dentista',
  COREN = 'Enfermeiro',
  CRBM = 'Biomédico',
  CRESS = 'Assistente Social',
  CREFITO = 'Fisioterapeuta',
  CREFONO = 'Fonaudiólogo',
  CRN = 'Nutricionista',
  CRP = 'Psicólogo',
  Outro = 'Outro',
  Nenhum = 'Nenhum',
}

export enum ProfessionalTypePicker {
  CRM = 'CRM',
  RMS = 'RMS',
  CRO = 'CRO',
  COREN = 'COREN',
  CRBM = 'CRBM',
  CRESS = 'CRESS',
  CREFITO = 'CREFITO',
  CREFONO = 'CREFONO',
  CRN = 'CRN',
  CRP = 'CRP',
  Outro = 'Registro profissional'
}

export enum StatesPicker {
  AC = 'Acre',
  AL = 'Alagoas',
  AP = 'Amapá',
  AM = 'Amazonas',
  BA = 'Bahia',
  CE = 'Ceará',
  DF = 'Distrito Federal',
  ES = 'Espírito Santo',
  GO = 'Goiás',
  MA = 'Maranhão',
  MT = 'Mato Grosso',
  MS = 'Mato Grosso do Sul',
  MG = 'Minas Gerais',
  PA = 'Pará',
  PB = 'Paraíba',
  PR = 'Paraná',
  PE = 'Pernambuco',
  PI = 'Piauí',
  RJ = 'Rio de Janeiro',
  RN = 'Rio Grande do Norte',
  RS = 'Rio Grande do Sul',
  RO = 'Rondônia',
  RR = 'Roraima',
  SC = 'Santa Catarina',
  SP = 'São Paulo',
  SE = 'Sergipe',
  TO = 'Tocantins'
}
